import * as Elements from './kontent/models/Elements'

export const isHiddenKontentItem = (indexingField: Elements.MultipleChoiceElement) => {
  if (indexingField?.value[0]) {
    const { codename } = indexingField.value[0]
    return codename === 'page_should_not_be_visible_in_search_engines'
  }
  return false
}
